import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import RadioBtn from '../../Form/RadioButton'
import theme from '../../../styling/theme'

interface StepProps {
  setAnswer: (e) => void
  answer: string
}

const Step4: FunctionComponent<StepProps> = ({ setAnswer, answer }) => {
  return (
    <Container>
      <p className="section-tag">Step 4 of 4</p>
      <Question>Are you spending money on any of the following</Question>
      <List>
        <Col>
          <li>Contractors</li>
          <li>Staff salaries</li>
          <li>Raw materials</li>
          <li>Utilities</li>
        </Col>

        <Col>
          <li>Software</li>
          <li>Clinical trials</li>
          <li>Consumables</li>
        </Col>
      </List>
      <BtnsContainer>
        <RadioBtn
          onClick={() => {
            setAnswer('Yes')
          }}
          isActive={answer === 'Yes'}
        >
          Yes
        </RadioBtn>
        <RadioBtn
          nomarginright
          onClick={() => {
            setAnswer('No')
          }}
          isActive={answer === 'No'}
        >
          No
        </RadioBtn>
      </BtnsContainer>
    </Container>
  )
}

export default Step4

const Container = styled.div`
  & .section-tag {
    margin-bottom: 10px;
  }
`

const Question = styled.p`
  color: ${theme.text.main};
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;

  @media (min-width: 1024px) {
    font-size: 20px;
    line-height: 30px;
  }
`

const BtnsContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 16px;
  @media (min-width: 768px) {
    max-width: 375px;
  }
  @media (min-width: 104px) {
    margin-top: 5rem;
  }
`
const List = styled.ul`
  margin-top: 30px;
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
  }
`
const Col = styled.div`
  & li {
    color: ${theme.text.greyLight};
    font-weight: 300;
    margin-bottom: 18px;
  }
  @media (min-width: 1024px) {
    width: 48%;
  }
`
